import { createSelector } from 'reselect';

import { Selector } from '../../../../types/selectors';
import { selectFirstMissionAchievement, selectMissionAchievements } from '../../selectors/missionAchievements';
import { selectUserMissionAchievements } from '../../selectors/userMissionAchievements';
import { UserAchievementStatuses } from '../../types/state/userMissions';
import { getNbValidatedBetsFromAchievement } from '../MissionDetailsAchievementProgress/selectMissionDetailsAchievementProgressContainerProps';

const selectMissionProgressBarNbWonAchievements: Selector<number | undefined> = createSelector(
  [selectMissionAchievements, selectFirstMissionAchievement, selectUserMissionAchievements],
  (missionAchievements, firstMissionAchievement, userMissionAchievements) => {
    const nbMissionAchievements = Object.keys(missionAchievements).length;

    if (nbMissionAchievements === 1) {
      const firstUserMissionAchievement = userMissionAchievements[0];

      if (firstUserMissionAchievement && firstMissionAchievement) {
        const { betslips } = firstUserMissionAchievement;
        const {
          eligibility: { nbBetsToPlace, nbBetsToWin },
        } = firstMissionAchievement;

        return getNbValidatedBetsFromAchievement(betslips, nbBetsToWin, nbBetsToPlace);
      }
    }

    return Object.keys(
      userMissionAchievements?.filter((achievement) => achievement?.status === UserAchievementStatuses.WON) ?? {},
    ).length;
  },
);

const selectMissionsProgressBarNbAchievements: Selector<number | undefined | null> = createSelector(
  [selectMissionAchievements, selectFirstMissionAchievement],
  (missionAchievements, firstMissionAchievement) => {
    const nbMissionAchievements = Object.keys(missionAchievements).length;

    if (nbMissionAchievements === 1) {
      if (firstMissionAchievement) {
        return firstMissionAchievement.eligibility.nbBetsToWin ?? firstMissionAchievement.eligibility.nbBetsToPlace;
      }
    }

    return nbMissionAchievements;
  },
);

export type MissionProgressBarContainerPropsType = {
  nbClips: number;
  nbCompleted: number;
};

const selectMissionProgressBarContainerProps: Selector<MissionProgressBarContainerPropsType> = createSelector(
  [selectMissionsProgressBarNbAchievements, selectMissionProgressBarNbWonAchievements],
  (nbClips, nbCompleted) => ({
    nbClips: nbClips ?? 0,
    nbCompleted: nbCompleted ?? 0,
  }),
);

export default selectMissionProgressBarContainerProps;
